<template>
  <div class="animated fadeIn" id="tab-referentiel">
    <b-row>
      <b-col md="8">
        <b-card no-body>
          <b-card-header>
            <i class="fa fa-list mr-2"></i>
            <strong>Référentiel IBAN - SIREN</strong>
          </b-card-header>
          <b-card-body>
            <b-button v-if="canAccess(rules.MANAGE_REF_IBAN_SIREN)"
              type="button"
              @click="create()"
              class="pull-right"
              size="md"
              variant="primary"
            >
              <i class="fa fa-plus"></i> Ajouter un IBAN - SIREN
            </b-button>
            <v-client-table :columns="columns" :data="items" :options="options">
              <div slot="iban" slot-scope="props">{{ props.row.iban }}</div>
              <div slot="siren" slot-scope="props">{{ props.row.siren }}</div>
              <div v-if="canAccess(rules.MANAGE_REF_IBAN_SIREN)" slot="action" slot-scope="props">
                <b-button
                  type="button"
                  @click.prevent="destroy(props.row.id)"
                  class="badge badge-danger mr-3 p-2"
                >
                  <i class="fa fa-remove"></i> Supprimer
                </b-button>
              </div>
            </v-client-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../../utils/auth'
import {espaceRPARules, hasRule} from '../../../utils/rulesHelper'

export default {
  data() {
    return {
      rules: espaceRPARules,
      columns: [
        "iban",
        "siren",
        "action"
      ],
      columnsClasses: {
        action: "action-md"
      },
      items: [],
      options: {
        headings: {
          iban: "IBAN",
          siren: "SIREN",
        },
        sortable: ["iban", "siren"],
        filterable: ["iban","siren"],
        perPage: 30,
        perPageValues: [30, 100, 300],
        texts: {
          filterPlaceholder: "IBAN, SIREN"
        }
      }
     
    }
  },
  mounted() {
   this.all();
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    canAccess(rule) {
      return hasRule(rule)
    },
    all() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/espaceRPA/ibanSiren")
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          this.items = response.data.ibanSirens;
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    create(){
      this.$router.push({ path: "/suivi-cotisations/iban-siren/create" });
    },
    destroy(id) {
      let self = this;
      this.$swal
        .fire({
          title: "Êtes-vous sûr?",
          text: "Voulez-vous vraiment supprimer cet IBAN / SIREN ?",
          type: "warning",
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor: "#ff1744",
          confirmButtonText: "Annuler",
          cancelButtonText: "Supprimer"
        })
        .then(result => {
          if (!result.value) {
            this.$store.commit("IS_LOADING", true);
            this.$axios
              .post("/espaceRPA/ibanSiren/delete/" + id)
              .then(response => {
                this.$store.commit("IS_LOADING", false);
                this.$swal({
                  position: "top",
                  type: "success",
                  title: "Suppression avec succès",
                  text: "L'IBAN a bien été supprimé pour ce SIREN",
                  showConfirmButton: false,
                  timer: 5000
                });
                this.all();
              })
              .catch(function(error) {
                self.$store.commit("IS_LOADING", false);
                self.$swal({
                  position: "top",
                  type: "warning",
                  title: "Attention !!",
                  text: "Un probléme est survenu, merci de contacter l'administrateur",
                  showConfirmButton: false,
                  timer: 5000
                });
              });
          }
        });
    },
    refresh() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/espaceRPA/ibanSiren/refreshExcel")
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          this.$swal({ position: 'top', type: 'success', title:'Actualisation en cours', text:'L\'actualisation du fichier peut prendre jusqu\'à 2 minutes. Veuillez patienter',showConfirmButton: false, timer: 5000})
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    exportXls(){
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/espaceRPA/ibanSiren/export")
        .then(response => {
          this.$store.commit("IS_LOADING", false);
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    }
  }
}
</script>
